const TFoodEditorScreen = {
    // English
    "enUS": {
        'NAME': 'Name',
        'DESCRIPTION': 'Description (Optional)',
        'PRICES': 'Prices',
        'SAVE': 'Save',
        'CANCEL': 'Cancel',
        'NEW_EXTRA': 'New Extra',
        'INGREDIENTS': 'Ingredients',
        'MAIN': 'Customizable',
        'OPTIONALS': 'Included',
        'EXTRAS': 'Extras',
        'CHANGE': 'Change',
        'REMOVE': 'Remove',
        'DEFAULT': '(DEFAULT)',
        'ADD': 'Add',
        'FREE': 'Free',
        'MEAT': 'Ex. Meat',
        'TOMATO': 'Ex. Tomato',
        'CHEESE': 'Ex. Cheese',
        'ADD_PRICE': 'Add Price',
    },
    // Spanish
    "esMX": {
        'NAME': 'Nombre',
        'DESCRIPTION': 'Descripción (Opcional)',
        'PRICES': 'Precios',
        'SAVE': 'Guardar',
        'CANCEL': 'Cancelar',
        'NEW_EXTRA': 'Nuevo Extra',
        'INGREDIENTS': 'Ingredientes',
        'MAIN': 'Personalizables',
        'OPTIONALS': 'Incluidos',
        'EXTRAS': 'Extras',
        'CHANGE': 'Cambiar',
        'REMOVE': 'Quitar',
        'DEFAULT': '(PREDET.)',
        'ADD': 'Agregar',
        'FREE': 'Gratis',
        'MEAT': 'Ej. Carne',
        'TOMATO': 'Ej. Tomate',
        'CHEESE': 'Ej. Queso',
        'ADD_PRICE': 'Agregar Precio',
    }
}
export default TFoodEditorScreen;